import React, { ReactNode } from "react";
import PropTypes from "prop-types";
import Modal from "react-responsive-modal";
import ViewPdf from "../ViewPdf";

interface IPreviewCvProps {
  // eslint-disable-next-line camelcase
  pdf_url: string;
}

interface IPreviewCvState {
  open: boolean;
}

class PreviewCv extends React.Component<IPreviewCvProps, IPreviewCvState> {
  static propTypes = {
    pdf_url: PropTypes.string.isRequired,
  };

  state = { open: false };

  onOpenModal = (): void => {
    this.setState({ open: true });
  };

  onCloseModal = (): void => {
    this.setState({ open: false });
  };

  render(): ReactNode {
    const { pdf_url: pdfUrl } = this.props;
    const { open } = this.state;

    return (
      <div>
        <button type="button" onClick={this.onOpenModal}>
          Preview CV
        </button>
        <Modal open={open} onClose={this.onCloseModal} center>
          <h2>Preview CV</h2>
          <ViewPdf pdf_url={pdfUrl} />
        </Modal>
      </div>
    );
  }
}

export default PreviewCv;
